var React = require('react');

function CookiesShape (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"kontakt","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","opacity":"0.932697114"},React.createElement("g",{"id":"cookies","transform":"translate(-275.000000, -1014.000000)","fill":"#231F20"},React.createElement("polygon",{"id":"Rectangle","points":"319 1014 813 1016.5 1116.71369 1016.5 1164.79199 1150.84357 1035 1138 275 1150.84357"}))));
}

CookiesShape.defaultProps = {"preserveAspectRatio":"none","viewBox":"0 0 890 137","version":"1.1"};

module.exports = CookiesShape;

CookiesShape.default = CookiesShape;
